export default {
  prices: {
    // Comparador homogéneo (R-27…R-29, §90 Fase 4A)
    hTitle: "Comparación homogénea",
    hMembers: "{n} presentaciones",
    hLowest: "precio menor",
    hLevel_presentation: "Presentación equivalente",
    hLevel_unit: "Precio por unidad",
    hLevel_product: "Media por producto",
    hLevelHint_presentation: "Presentaciones de la misma agrupación homogénea: mismo principio activo, dosis, forma, vía y envase. La comparación más limpia.",
    hLevelHint_unit: "Misma molécula, dosis y forma con distinto tamaño de envase, normalizado a precio por unidad. Asume equivalencia entre envases.",
    hLevelHint_product: "Media del precio por unidad de cada marca. Útil para una visión de cartera, no para decisiones de precio concretas.",
    hColPack: "Envase",
    hColPerUnit: "PVP / unidad",
    hColVsOwn: "Δ vs propio",
    hColVsLowest: "Δ vs precio menor",
    hColBrand: "Marca",
    hColPresentations: "Presentaciones",
    hColAvgPerUnit: "Media PVP / unidad",
    hColRange: "Rango",
    hAtLowest: "al precio menor",
    hExcludedTitle: "{n} sin comparar por no poder normalizarse:",
    hReason_no_units: "envase no contable",
    hReason_no_price: "sin precio",
    hScopeNote: "Solo canal farmacia: PVP con IVA del Nomenclátor de facturación y PVL de los listados mensuales de agrupaciones homogéneas del Ministerio. Los precios hospitalarios reales no son públicos.",
    hUpdated: "datos del {date}",
    hOnlyAh: "(comparación homogénea)",
    hError: "No se pudo cargar la comparación homogénea",
    title: "Comparador de Precios",
    subtitle: "Compara solo lo comparable: las presentaciones de una misma agrupación homogénea (mismo principio activo, dosis, forma y envase), hoy y mes a mes desde 2015.",
    errorProducts: "No se pudo cargar tu portfolio. Comprueba tu conexión.",
    errorComparison: "No se pudo cargar la evolución de precios. Comprueba tu conexión.",
    retry: "Reintentar",
    loadingPortfolio: "Cargando portfolio…",
    productLabel: "Tu producto",
    noPriceData: "· sin agrupación homogénea",
    loadingComparison: "Cargando comparativa…",
    // Multifiltro (feedback de Carlos, 20 oct 2026)
    filtersTitle: "O busca una agrupación",
    filterAtc: "ATC",
    filterAtcPh: "p. ej. C09DA",
    filterPa: "Molécula",
    filterPaPh: "p. ej. olmesartán",
    filterProduct: "Producto",
    filterProductPh: "p. ej. Olmetec",
    filterCn: "Presentación (CN)",
    filterCnPh: "p. ej. 674888",
    filterSearch: "Buscar",
    filterClear: "Limpiar",
    ahLabel: "Agrupación homogénea",
    ahOption: "{code} · {name} · {n} pres.",
    ahOwn: "tuyas: {n}",
    ahNone: "Ninguna agrupación cumple esos filtros.",
    ahTruncated: "Hay más de 200: afina los filtros.",
    metricPvp: "PVP con IVA",
    metricPvl: "PVL",
    metricHint: "El PVL sale de los listados mensuales de agrupaciones homogéneas; el Nomenclátor de facturación solo publica el PVP.",
    periodLabel: "Periodo",
    period_1: "1 año",
    period_3: "3 años",
    period_5: "5 años",
    period_all: "Desde 2015",
    historyTitle: "Evolución del precio · agrupación {code}",
    lowestLine: "Precio menor de la agrupación",
    noSeriesData: "No hay precios para mostrar en este periodo. Marca presentaciones en la tabla inferior.",
    noAhForProduct: "Este producto no está en ninguna agrupación homogénea (marca sin genéricos o canal hospitalario): se muestra solo su propia evolución.",
    presentationsLabel: "Presentaciones de la agrupación",
    toggleHint: "Marca o desmarca para mostrarlas en el gráfico",
    omittedProducts: " · {n} presentaciones más sin mostrar",
    colProduct: "Producto",
    colLaboratory: "Laboratorio",
    colLatest: "Último precio",
    colDate: "Mes",
    colDiff: "Δ vs tu producto",
    colMonths: "Meses",
    noData: "sin datos",
    otherPack: "otro envase",
    otherPackHint: "El precio por unidad de un envase distinto al tuyo mide sobre todo el tamaño del envase: los envases grandes salen más baratos por unidad, incluido el tuyo. No es una ventaja de precio del competidor.",
    tracked: "en tu competencia",
    trackedHint: "Está en tu lista de Competidores",
    ownTag: "tuyo",
    leftGroup: "ya no está en la agrupación",
    noCompetitors: "No hay otras presentaciones con precio en esta agrupación.",
    tableFooter: "Δ: diferencia del último precio frente a tu producto (verde = más barato que el tuyo). Una agrupación homogénea reúne presentaciones con el mismo principio activo, dosis, forma, vía y envase.",
  },
};
